const inputTokens = ({ fontSizes, lineHeights, colors }) => ({
  space: {
    icon: '40px',
  },
  sizes: {
    icon: {
      container: '40px',
    },
    image: {
      width: '27px',
      height: '27px',
    },
  },
  fontSizes: {
    text: fontSizes.body[2],
    label: fontSizes.body[2],
    shrink: fontSizes.body[0],
    helper: fontSizes.body[0],
  },
  lineHeight: lineHeights.body,
  colors: {
    default: {
      text: colors.neutrals[0],
      icon: colors.neutrals[2],
      color: colors.neutrals[4],
      label: colors.neutrals[2],
      bg: colors.white,
    },
    disabled: {
      text: colors.neutrals[4],
      icon: colors.neutrals[4],
      color: colors.neutrals[6],
      label: colors.neutrals[4],
      bg: colors.neutrals[7],
    },
    negative: {
      text: colors.negative.default,
      icon: colors.negative.default,
      color: colors.negative.default,
      label: colors.negative.default,
      bg: colors.negative.lightest,
    },
    branded: {
      text: colors.neutrals[0],
      icon: colors.shadesPrimary.default,
      color: colors.shadesPrimary.default,
      label: colors.shadesPrimary.default,
      bg: colors.shadesPrimary.lightest,
    },
    focus: {
      text: colors.neutrals[0],
      icon: colors.brandPrimary['50'],
      color: colors.brandPrimary['50'],
      label: colors.brandPrimary['50'],
      bg: colors.shadesPrimary.lightest,
    },
    invalid: {
      text: colors.negative.default,
      icon: colors.negative.default,
      color: colors.negative.default,
      label: colors.negative.default,
      bg: colors.negative.lightest,
    },
  },
});

export default inputTokens;
